import { useEffect, useState } from 'react';
import { Switch } from './switch';
import { SunIcon, MoonIcon } from '@heroicons/react/20/solid';

export default function DarkModeToggle() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return stored === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('darkMode', String(isDark));
  }, [isDark]);

  return (
    <div className="flex items-center gap-2">
      <SunIcon className="size-4 text-zinc-500 dark:text-zinc-400" />
      <Switch checked={isDark} onChange={setIsDark} color="zinc" aria-label="Toggle dark mode" />
      <MoonIcon className="size-4 text-zinc-500 dark:text-zinc-400" />
    </div>
  );
}
